import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { setDataLayer } from 'shared/actions/globals';
import { withTranslate } from 'shared/hocs/withTranslate';
import { isValidPhone } from 'shared/validations/validations';
import { withFetch } from 'shared/hocs/withFetch';
import { InputPhoneNumber, InputText, Button } from 'shared/components/UI';
import ModalWrapper from 'shared/components/ModalWrapper/ModalWrapper';
import { EVENTS } from 'shared/constants/gtmEvents';
import { isUlfLeasing, isUlf24Leasing } from 'shared/helpers/leasing/utils';

import {
  prepareParamsForCreditMarketRequest,
  sendCreditMarket,
} from 'shared/helpers/leasing/creditmarket';

import {
  isCreditmarketNotClearedProposalAvailable,
  isCreditmarketProposalAvailable,
  prepareParamsForLeasingLeadRequest,
  createAFinanceLeda,
  createAutoMoneyLead,
} from 'shared/helpers/leasing/myAuto';

import { createUlfLead, getUlfParams } from 'shared/helpers/leasing/ulf';
import { createUlf24Lead } from 'shared/helpers/leasing/ulf24';

import { withLeasingParams } from 'shared/hocs/withLeasingParams';
// import withHapai from 'shared/hocs/withHapai';

import RecallForm from '../RecallForm/RecallForm';
// eslint-disable-next-line css-modules/no-unused-class
import s from './LeasingQuestions.css';

const isMobile = __APP__ === 'mobile';
class LeasingQuestions extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    leasingParams: PropTypes.shape(),
    //
    setDataLayer: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    leasingParams: null,
  };

  state = {
    userName: '',
    phone: '',
    disableBtnLeasing: false,
    errorMessage: '',
    successMessage: '',
    showRecall: false,
  };

  onLeadCreated = (success, partner) => {
    const eventName = `${partner ? `${partner}-` : ''}lead-create-${
      success ? 'success' : 'fail'
    }-questions`;
    if (EVENTS.leasing[eventName]) this.props.setDataLayer(EVENTS.leasing[eventName]);
    else console.error(`Event: ${eventName} not found`);
  };

  onSubmitHandler = () => {
    if (!this.validateForm() || !this.props.leasingParams) return false;
    this.setState({ disableBtnLeasing: true });
    let partnerName = '';
    const isCreditMarket =
      isCreditmarketNotClearedProposalAvailable(this.props.advert) ||
      isCreditmarketProposalAvailable(this.props.advert);

    // if (!isCreditMarket && isAutoMoneyLeasing(this.props.leasingParams)) {
    //   partnerName = 'automoney';
    // } else 
    if (isUlf24Leasing(this.props.leasingParams)) {
      partnerName = 'ulf24';
    } else if (isUlfLeasing(this.props.leasingParams)) {
      partnerName = 'ulf';
    } else if (isCreditMarket) {
      partnerName = 'creditmarket';
    }

    let submit;

    if (partnerName === 'automoney') {
      submit = this.submitAutoMoneyLeasingLead;
    } else if (partnerName === 'creditmarket') {
      submit = this.submitCreditmarketLeasingLead;
    } else if (partnerName === 'ulf24') {
      submit = this.submitUlfLeasingLead;
    } else if (partnerName === 'ulf') {
      submit = this.submitUlfLeasingLead;
    } else {
      submit = this.submitAFinanceLeasingLead;
    }

    submit(success => {
      if (success) {
        this.setState({ showRecall: true });
        this.onLeadCreated(true, partnerName);
      } else {
        this.setState({ errorMessage: 'Произошла ошибка' });
        this.onLeadCreated(false, partnerName);
      }
      this.setState({ disableBtnLeasing: false });
    });

    return true;
  };

  submitCreditmarketLeasingLead = cb => {
    const { advert, fetch } = this.props;
    const { phone, userName } = this.state;
    const cmParams = prepareParamsForCreditMarketRequest({ ...advert, phone, userName });
    sendCreditMarket(cmParams, fetch)
      .then(result => {
        cb(result && result.id);
      })
      .catch(() => {
        cb(false);
      });
    this.props.setDataLayer(EVENTS.leasing['creditmarket-questions-form-sumbit']);
  };

  submitAFinanceLeasingLead = cb => {
    const { advert, leasingParams, fetch } = this.props;
    const leadsParams = prepareParamsForLeasingLeadRequest(this.state, advert, leasingParams, {});
    createAFinanceLeda(leadsParams, advert, fetch)
      .then(result => {
        cb(result && result.id);
      })
      .catch(() => {
        cb(false);
      });
    this.props.setDataLayer(EVENTS.leasing['questions-form-sumbit']);
  };

  submitAutoMoneyLeasingLead = cb => {
    const { advert, leasingParams, fetch } = this.props;
    const leadsParams = prepareParamsForLeasingLeadRequest(this.state, advert, leasingParams, {});
    createAutoMoneyLead(leadsParams, advert, fetch)
      .then(result => {
        cb(result && result.id);
      })
      .catch(() => {
        cb(false);
      });
    this.props.setDataLayer(EVENTS.leasing['questions-form-sumbit']);
  };

  submitUlfLeasingLead = cb => {
    const { phone, userName } = this.state;
    const { advert, leasingParams, fetch } = this.props;

    const leadParams = getUlfParams({ phone, userName, leasingParams, advert });
    createUlfLead(leadParams, fetch)
      .then(result => {
        cb(result && result.id);
      })
      .catch(() => {
        cb(false);
      });
    this.props.setDataLayer(EVENTS.leasing['questions-form-sumbit']);
  };

  submitUlf24LeasingLead = cb => {
    const { phone, userName } = this.state;
    const { advert, leasingParams, fetch } = this.props;

    const leadParams = getUlfParams({ phone, userName, leasingParams, advert });
    createUlf24Lead(leadParams, fetch)
      .then(result => {
        cb(result && result.id);
      })
      .catch(() => {
        cb(false);
      });
    this.props.setDataLayer(EVENTS.leasing['questions-form-sumbit']);
  };

  // submitHapaiLeasingLead = cb => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadParams = {
  //     phone,
  //     userName,
  //     advert,
  //     leasingParams,
  //     term: leasingParams.term,
  //     prepaid: leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
  //     price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
  //     userStorageId: localStorage.getItem('applensDeviceId') || '',
  //   };
  //   console.log('Create Hapai Lead');
  //   createHapaiLead(leadParams, fetch)
  //     .then(data => cb(data && data.success))
  //     .catch(() => cb(false));
  //   this.props.setDataLayer(EVENTS.leasing['hapai-questions-form-sumbit']);
  //   return false;
  // };

  changeHandler = (field, value) => {
    this.setState({ [field]: value, errorMessage: '' });
  };

  validateForm = () => {
    const { phone, userName } = this.state;
    if (!phone || !isValidPhone(phone.replace(/\s/g, ''))) {
      this.setState({ errorMessage: 'Некорректный номер телефона' });
      return false;
    }

    if (!userName) {
      this.setState({ errorMessage: 'Некорректное имя' });
      return false;
    }

    return true;
  };
  render() {
    const { userName, phone, errorMessage, successMessage, disableBtnLeasing } = this.state;
    const { t } = this.props;
    const disabledBtn = disableBtnLeasing || !userName || !phone;

    const rootClass = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rootClass}>
        <div className={s.info}>
          <div className={s.infoTitle}>{t('Остались вопросы?')}</div>
          <p>{t('Расскажем про “Ежемесячный платёж” за 3 минуты')}</p>
        </div>
        <div>
          <form className={s.form}>
            <InputText
              name={'userName'}
              value={userName}
              placeholder={userName || t('Имя')}
              changeHandler={this.changeHandler}
            />
            <InputPhoneNumber name={'phone'} value={phone} changeHandler={this.changeHandler} />

            <Button
              disabled={disabledBtn}
              type="button"
              onClick={this.onSubmitHandler}
              text="Консультация"
            />
          </form>
          <div className={s.messageBlock}>
            {(errorMessage || successMessage) && (
              <span
                className={cx(
                  { [s.errorMessage]: errorMessage },
                  { [s.successMessage]: successMessage },
                )}
              >
                {t(errorMessage || successMessage)}{' '}
              </span>
            )}
          </div>
        </div>
        {this.state.showRecall && (
          <ModalWrapper
            toggleModal={() => this.setState({ showRecall: false })}
            show={this.state.showRecall}
          >
            <RecallForm timeUp={() => this.setState({ showRecall: false })} />
          </ModalWrapper>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

export default withStyles(s)(
  connect(
    null,
    mapDispatchToProps,
  )(withFetch(withTranslate(withLeasingParams(LeasingQuestions)))),
);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/LeasingQuestions/LeasingQuestions.js